import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Cek emailmu untuk link reset");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-5rem)] lumina-bg-soft flex items-center justify-center py-16" data-testid="forgot-page">
      <div className="lumina-card w-full max-w-md p-10">
        <div className="lumina-label mb-2">Lupa Password</div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-6">Reset Password</h1>
        {sent ? (
          <div className="bg-[#E8F0FA] rounded-2xl p-5 text-sm text-[#1A1728]">
            <p>Jika email <strong>{email}</strong> terdaftar, kami sudah mengirim link reset password. Cek inbox/spam ya.</p>
            <p className="text-xs text-[#5C5870] mt-3">*Jika API key Resend belum dipasang admin, link reset bisa diambil dari server log.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-[#5C5870]">Masukkan email akunmu, kami kirim link reset.</p>
            <input required type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] outline-none" data-testid="forgot-email" />
            <button disabled={loading} className="lumina-btn-primary w-full" data-testid="forgot-submit">{loading ? "Mengirim…" : "Kirim Link Reset"}</button>
          </form>
        )}
        <p className="text-sm text-[#5C5870] mt-6 text-center"><Link to="/login" className="text-[#6B4BA3] font-medium">Kembali ke login</Link></p>
      </div>
    </div>
  );
}
